import { render, staticRenderFns } from "./SSOPairingModeSelection.vue?vue&type=template&id=a859d8f8&scoped=true"
import script from "./SSOPairingModeSelection.vue?vue&type=script&lang=ts"
export * from "./SSOPairingModeSelection.vue?vue&type=script&lang=ts"
import style0 from "./SSOPairingModeSelection.vue?vue&type=style&index=0&id=a859d8f8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a859d8f8",
  null
  
)

export default component.exports